// extracted by mini-css-extract-plugin
export default {"toastMsg":"Toastify_toastMsg__8uWTd"};